import { render, staticRenderFns } from "./friendList.vue?vue&type=template&id=e26d04e8&scoped=true"
import script from "./friendList.vue?vue&type=script&lang=js"
export * from "./friendList.vue?vue&type=script&lang=js"
import style0 from "./friendList.vue?vue&type=style&index=0&id=e26d04e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e26d04e8",
  null
  
)

export default component.exports